// composables/useAuth.js
import axios from 'axios'

export function useAuth() {
  
  // JWT 검증 (Node.js에서 member 테이블 체크/생성)
  const verifyToken = async (token) => {
    try {
      const response = await axios.post('/api/login/verify', { token })
      return response.data
    } catch (error) {
      console.error('토큰 검증 실패:', error)
      return { success: false, message: error.response?.data?.message || '검증 실패' }
    }
  }
  
  // 팝업 로그인 열기 (일반 ID/PW 로그인)
  const openLoginPopup = (onSuccess, onError) => {
    window.open(
      `https://amadiary.com/api/boda_login.php?origin=${encodeURIComponent(window.location.origin)}`,
      'boda_login',
      'width=480,height=650,scrollbars=yes'
    )
    
    const handleMessage = async (event) => {
      if (!event.origin.includes('amadiary.com')) return
      
      if (event.data && event.data.success !== undefined) {
        if (event.data.success) {
          const token = event.data.token
          
          // Node.js에 검증 요청 (member 테이블 체크/생성)
          const verifyResult = await verifyToken(token)
          
          if (verifyResult.success) {
            localStorage.setItem('auth_token', token)
            console.log('팝업 로그인 성공:', event.data.user, verifyResult.status)
            
            if (onSuccess) onSuccess({ ...event.data, status: verifyResult.status })
          } else {
            console.error('토큰 검증 실패:', verifyResult.message)
            if (onError) onError(verifyResult.message)
          }
        } else {
          console.log('팝업 로그인 실패:', event.data.message)
          if (onError) onError(event.data.message)
        }
        
        window.removeEventListener('message', handleMessage)
      }
    }
    
    window.addEventListener('message', handleMessage)
  }
  
  // URL에서 토큰 확인 (소셜 로그인 리다이렉트 콜백용)
  const checkUrlToken = async (onSuccess, onError) => {
    const params = new URLSearchParams(window.location.search)
    const urlToken = params.get('boda_token')
    const error = params.get('login_error')
    
    if (urlToken) {
      // URL 파라미터 제거
      window.history.replaceState({}, '', window.location.pathname)
      
      // Node.js에 검증 요청 (member 테이블 체크/생성)
      const verifyResult = await verifyToken(urlToken)
      
      if (verifyResult.success) {
        localStorage.setItem('auth_token', urlToken)
        console.log('소셜 로그인 성공:', verifyResult.status)
        
        if (onSuccess) onSuccess({ status: verifyResult.status })
      } else {
        if (onError) onError(verifyResult.message)
      }
      return true
    }
    
    if (error) {
      window.history.replaceState({}, '', window.location.pathname)
      if (onError) onError(decodeURIComponent(error))
      return false
    }
    
    return false
  }
  
  return {
    openLoginPopup,
    checkUrlToken,
    verifyToken
  }
}